import React from "react";

const Map = () => {
  return (
    <div className="container mt-4" style={{ marginBottom: "70px" }}>
      <h2 className="text-center mb-3">Our Location</h2>
      <div className="d-flex justify-content-center">
        <iframe
          title="Institute Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.1794763648572!2d77.50147747358879!3d12.960364615127517!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae3f9f73653b9b%3A0xc24b81f018458ea7!2sIAS%20Jnani!5e0!3m2!1sen!2sin!4v1744169522941!5m2!1sen!2sin"
          width="100%"
          height="450"
          style={{ border: 0, borderRadius: "10px" }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  );
};

export default Map;
